import React, { useEffect, useState } from 'react';
import AleLauncher from './AleLauncher';
import AleWindow from './AleWindow';
import { useIsMobile } from './hooks/useIsMobile';
import { ALE_CONFIG, ALE_TEXTS } from './config';

// Widget do assistente "Ale".
// Orquestra o estado aberto/fechado:
//  - Desktop: abre já aberto.
//  - Celular: começa fechado (só o ícone).
// A janela (AleWindow) só é montada quando aberta, para não custar nada fechada.
const AleWidget = () => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  // Garante que o estado inicial (desktop aberto / mobile fechado) seja aplicado
  // apenas uma vez, sem "brigar" com o clique do usuário depois.
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (initialized) return;
    setOpen(
      isMobile
        ? ALE_CONFIG.openByDefaultOnMobile
        : ALE_CONFIG.openByDefaultOnDesktop
    );
    setInitialized(true);
  }, [isMobile, initialized]);

  if (!ALE_CONFIG.enabled) return null;

  return (
    <>
      {open && <AleWindow onClose={() => setOpen(false)} />}
      <AleLauncher
        open={open}
        onClick={() => setOpen((v) => !v)}
        label={ALE_TEXTS.launcherLabel}
      />
    </>
  );
};

export default AleWidget;
